import DefaultConsents from '@/api/services/default-consents'

const state = {
    defaultConsents: null
}

const getters = {
    defaultConsents(state) {
        return state.defaultConsents
    }
}

const mutations = {
    setDefaultConsents(state, defaultConsents) {
        state.defaultConsents = defaultConsents
    }
}

const actions = {
    getDefaultConsents({ commit }) {
        return DefaultConsents()
            .getDefaultConsents()
            .then(data => {
                if (data.data) {
                    commit('setDefaultConsents', data.data)

                    return data.data
                }
            })
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}